export default __webpack_public_path__ + "static/media/89db7a3c86f759ed.da4c89aab316f0c23b50f2bfde7e28a5.svg";